import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { SentryService } from './sentry.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface cioCustomer {
  email?: string,
  name?: string,
  createdAt?: number,
  created_at?: number,
  updatedAt?: number,
  anonymousId?: number, // this allows to link a customer to anonymous events for the anonymousId user
  _update?: boolean, // If this is true, will update customer. However from my experience it also does when it's not declared and customer (email is Id) already exists
  firstConnexionDate?: number;
  lastConnexion?: number,
  phone?: number,
  country?: string,
  anonymous_id?: number,
  websiteCreated?: boolean,
  subscription?: string,
  subscriptionExpirationDate?: number,
  trialExpirationDate?: number,
  creditsRemaining?: number,
  companyName?: string,
  suspended?: boolean,
  devEnvironment?: boolean,
  emailNotifications?: boolean, // What's the difference between emailNotifications, optinLeads and optinPromo ?
  optinLeads?: boolean;
  optinPromo?: boolean;
}

export interface cioEvent {
  eventName: string,
  eventData: Object
}

export interface cioAnonymousEvent {
  eventName: string,
  type: 'page' | 'action' | 'other',
  anonymousId: string,
  eventData: Object
}

/**
 * Customer IO creates customers and transmits events to CustomerIO so we can create transactional, broadcast and campaign messages by email/sms/push notifications
 */
@Injectable({
  providedIn: 'root'
})
export class CustomerIoService {
  private baseApiURL = 'https://865gufe6se.execute-api.us-east-1.amazonaws.com/dev/'; // TODO must replace with environment variable subdomain after domain update on the API
  constructor(private sentryService: SentryService, private http: HttpClient) { }

  /**
   * Create or update a customer on cio without Auth token (used before registration is complete). 
   * For update, add the "_update": false param inside data 
   * @returns {}
   */
  cioCreateCustomer(data: cioCustomer): Observable<Object> {
    const url = this.baseApiURL + 'customer-io/customer';
    const httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Anonymous: 'Anonymous'
      })
  };
    return this.http.put(url, data, httpOptions);
  }

  /**
   * Send an event that will be associated to the email belonging to the auth token used 
   */
  cioSendEvent(data: cioEvent) {
    const url = this.baseApiURL + 'customer-io/event';
    return this.http.post(url, data);
  }

  /**
   * Send an anonymous event without token. Anonymous tokens can be associated to a customer later thanks to the anonymousId
   */
  cioSendAnonymousEvent(data: cioAnonymousEvent) {
    const url = this.baseApiURL + 'customer-io/anonymousEvent';
    return this.http.post(url, data);
  }

}
